import React from "react";
import { Modal, Button, Loader } from "ui-kit-ck-consultant";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faTrash } from "@fortawesome/free-solid-svg-icons";

import axiosConfig from "../../utils/axiosConfig";
import AppointmentPicker from "../general/AppointmentPicker";
import ExpertSelect from "../general/ExpertSelect";

// Prise / modification du RDV depuis le dossier.
// Seuls les créneaux libres sont sélectionnables (cf. AppointmentPicker).
// Un dossier sans expert du RDV (créé par une assistante) le choisit ici.
export default class ModalAppointment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoad: false,
      dateAppointment: "",
      hourAppointment: "",
      expertId: "",
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.show !== this.props.show && this.props.show) {
      this.setState({
        dateAppointment: this.props.dateAppointment || "",
        hourAppointment: this.props.hourAppointment
          ? String(this.props.hourAppointment).slice(0, 5)
          : "",
        expertId: "",
      });
    }
  }

  save = (date, time) => {
    this.request("folder/set-appointment", {
      id: this.props.id,
      date,
      time,
      expertId: this.props.appointmentExpertId ? null : this.state.expertId,
    });
  };

  cancel = () => {
    this.request("folder/cancel-appointment", { id: this.props.id });
  };

  request = (url, data) => {
    this.setState({ isLoad: true }, () => {
      axiosConfig(url, { data })
        .then((res) => {
          if (res.data && res.data.success) {
            this.setState({ isLoad: false }, () => {
              this.props.getFolder(false);
              this.props.onClose();
            });
          } else {
            this.setState({ isLoad: false }, () =>
              alert(
                (res.data && res.data.message) || "Une erreur est survenue.",
              ),
            );
          }
        })
        .catch(() =>
          this.setState({ isLoad: false }, () =>
            alert("Une erreur est survenue."),
          ),
        );
    });
  };

  render() {
    const hasAppointment = !!(
      this.state.dateAppointment && this.state.hourAppointment
    );
    const expertId = this.props.appointmentExpertId || this.state.expertId;

    return (
      <>
        <Modal
          show={this.props.show}
          onClose={this.props.onClose}
          title="Rendez-vous"
        >
          {this.props.appointmentCanceled ? (
            <p className="mb-20" style={{ fontSize: 13, color: "#6b6b6b" }}>
              Le rendez-vous a été annulé. Le créneau est libre, vous pouvez en
              fixer un nouveau.
            </p>
          ) : null}
          {this.props.visioInstant ? (
            <p className="mb-20" style={{ fontSize: 13, color: "#b35c00" }}>
              Ce dossier est en visio instantanée. Fixer un RDV la désactivera
              et le client verra la confirmation du RDV.
            </p>
          ) : null}
          {this.props.appointmentExpertId ? null : (
            <div className="mb-20">
              <ExpertSelect
                value={this.state.expertId}
                onChange={(value) =>
                  this.setState({
                    expertId: value,
                    dateAppointment: "",
                    hourAppointment: "",
                  })
                }
              />
            </div>
          )}
          {expertId ? (
            <AppointmentPicker
              date={this.state.dateAppointment}
              hour={this.state.hourAppointment}
              excludeFolderId={this.props.id}
              expertId={expertId}
              onChange={({ date, hour }) =>
                this.setState({ dateAppointment: date, hourAppointment: hour })
              }
            />
          ) : null}
          <div className="mt-20 d-flex" style={{ gap: 10 }}>
            <Button
              outline
              red
              text="Annuler le RDV"
              disabled={
                !this.props.dateAppointment ||
                !this.props.hourAppointment ||
                !!this.props.appointmentCanceled
              }
              onClick={this.cancel}
            >
              <FontAwesomeIcon icon={faTrash} />
            </Button>
            <Button
              text="Enregistrer le RDV"
              disabled={!hasAppointment}
              onClick={() =>
                this.save(
                  this.state.dateAppointment,
                  this.state.hourAppointment,
                )
              }
            >
              <FontAwesomeIcon icon={faSave} />
            </Button>
          </div>
        </Modal>
        <Loader show={this.state.isLoad} />
      </>
    );
  }
}
